import { PAGES } from 'src/app/common/types/types';
import { API_HOST_MANIFESTEEM } from 'common/config/constants';
import { ApiResponse } from 'common/types/api';
import { getAuthHeader } from 'common/utils/auth';

type Method = 'GET' | 'POST' | 'PUT' | 'PATCH' | 'DELETE';

type FetchOptions<Body> = {
  method: Method;
  url: string;
  payload?: Body;
} & RequestInit;

export type RequestOptions = {
  signal?: AbortSignal;
};

export const authorizedFetch = async <Response = void, Body = void>(
  { method, url, payload }: FetchOptions<Body>,
  options?: RequestOptions,
): Promise<{ res: Response; statusCode: number }> => {
  const config = {
    method,
    headers: {
      'Content-Type': 'application/json',
      Authorization: getAuthHeader(),
    },
    signal: options?.signal,
  } as RequestInit;

  if (payload) {
    config['body'] = JSON.stringify(payload);
  }

  const res = await fetch(`${API_HOST_MANIFESTEEM}/api/${url}`, config);

  if (res.status === 401) {
    window.location.href = `/${PAGES.SIGN_IN}`;
  }

  try {
    const responseData = (await res.json()) as ApiResponse<Response>;

    return {
      res: responseData.data,
      statusCode: res.status,
    };
  } catch {
    return {
      // TODO: Shouldn't return Response as empty object. Has to be a different type.
      res: {} as Response,
      statusCode: res.status,
    };
  }
};
